import { Center, Loader, MantineProvider } from "@mantine/core";
import { PropsWithChildren, Suspense, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { theme } from "@/app/theme";

import { ErrorFallback } from "@/shared/components/ErrorFallback";

export default function MainLayout({ children }: PropsWithChildren) {
  useEffect(() => {
    document.body.classList.add("mainLayout");

    return () => {
      document.body.classList.remove("mainLayout");
    };
  }, []);

  return (
    <MantineProvider theme={theme}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Suspense
          fallback={
            <Center mih="100dvh">
              <Loader size="lg" />
            </Center>
          }
        >
          {children}
        </Suspense>
      </ErrorBoundary>
    </MantineProvider>
  );
}
